import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';

interface DailyBriefController { isOpen: boolean; open: () => void; close: () => void; }
const Ctx = createContext<DailyBriefController | null>(null);

export function DailyBriefProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const value = useMemo(() => ({ isOpen, open, close }), [isOpen, open, close]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}
export function useDailyBrief(): DailyBriefController {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useDailyBrief must be used within DailyBriefProvider');
  return ctx;
}
